import React, { useState, useEffect, useContext } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useLazyGetDetailViewDetailsQuery } from '@src/store/services/cdb/onlineServices';
import { FileContext } from '@src/routes/Routes';
import { LoadingScreen } from '@src/common/LoadingScreen';
import { DetailViewTable } from './DetailViewTable';
import CryptoJS from 'crypto-js';
import { encdata } from '@src/constants';
interface encryData {
  firstName: string;
  lastName: string;
  empId?: string;
  customerName: string;
  cescustnbr: string;
  relationship: string;
  transId: string;
  transSetId: string;
  fileID: string;
  reportType?: string;
  processingDt?: string;
  subscrId?: string;
}
export const DetailView = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [detailView] = useLazyGetDetailViewDetailsQuery();
  const [encryData, setEncryData] = useState<encryData | undefined>();
  const [detailViewList, setDetailViewList] = useState<any[]>([]);
  const router = useRouter();
  const { fileData } = useContext(FileContext);
  const { encryptedData } = router.getRouteParams();

  useEffect(() => {
    if (encryptedData) {
      const decryptedData = CryptoJS.AES.decrypt(
        decodeURIComponent(encryptedData),
        encdata
      ).toString(CryptoJS.enc.Utf8);
      const linkData = JSON.parse(decryptedData);
      setEncryData(linkData);
    }
  }, [encryptedData]);

  useEffect(() => {
    if (encryData) {
      const {
        firstName,
        lastName,
        empId,
        customerName,
        cescustnbr,
        relationship,
        transId,
        transSetId,
        fileID,
        subscrId,
        reportType,
      } = encryData;

      const fetchDetails = async () => {
        const response = await detailView({
          transSetId,
          lastName,
          firstName,
          empId: empId ?? subscrId,
          transFileId: fileID,
          platform: 0,
          customerName,
          cescustnbr,
          relationship,
          transId,
        });
        setDetailViewList(response?.data);
        setIsLoading(false);
      };

      fetchDetails();
    }
  }, [encryData, detailView]);

  // Global destructuring of `cal`
  const {
    firstName,
    lastName,

    customerName,
    cescustnbr,
    relationship,
    transId,
    transSetId,
    fileID,
    processingDt,
  } = encryData || {};

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <React.Fragment>
      <Router.MetaTags title="Detail View" />
      <Layout.Stack
        css={{
          paddingTop: '40px',
          td: {
            backgroundColor: '#deebf4',
          },
        }}
        alignLayout="center"
      >
        <Layout.Stack
          css={{
            alignItems: 'stretch',
            width: '100%',
            maxWidth: '$web.semantic.max-width',
          }}
        >
          <Grid
            css={{
              width: '100%',
              paddingBottom: '10px',
            }}
          >
            <Grid.Col span="100%">
              <Text
                css={{
                  color: '$web.semantic.color.text.content.primary',
                  h1: {
                    margin: '0',
                  },
                }}
              >
                <h1>Detail View</h1>
              </Text>
            </Grid.Col>
            <Grid.Col span="100%">
              <Text>
                <b>Customer Submission group: </b>
                {customerName}
              </Text>
              <br />
              <Text>
                <b>Processing Date: </b> {processingDt}
              </Text>
              <br />
              <Text>
                <b>Member name: </b>
                {lastName}, {firstName}
              </Text>
            </Grid.Col>
          </Grid>
          <DetailViewTable detailViewList={detailViewList} />
        </Layout.Stack>
      </Layout.Stack>
    </React.Fragment>
  );
};
